import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'event_list_table_view';

export const useEventListTableViewTranslation = (): UseTranslationResponse<'entities', typeof keyPrefix> => {
  return useTranslation('entities', { keyPrefix });
};

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    sample: 'Фото события',
    top_match: 'Наибольшее совпадение',
    info: 'Данные события',
    attributes: 'Атрибуты',
    no_data: 'Нет данных',
    no_match: 'Наибольшее совпадение отсутствует',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    sample: 'Event photo',
    top_match: 'Top match',
    info: 'Event data',
    attributes: 'Attributes',
    no_data: 'No data',
    no_match: 'Top match is missing',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    sample: 'Foto del evento',
    top_match: 'Mayor coincidencia',
    info: 'Datos del evento',
    attributes: 'Atributos',
    no_data: 'Sin datos',
    no_match: 'La mayor coincidencia no está disponible',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    sample: 'Foto do evento',
    top_match: 'Maior correspondência',
    info: 'Dados do evento',
    attributes: 'Atributos',
    no_data: 'Sem dados',
    no_match: 'A maior correspondência não está disponível',
  },
}) : {}) as Record<string, unknown>;
